<template>
  <section class="vbox">
    <section class="scrollable padder">
      <Breadcrumb :items="breadcrumbList"/>
      <ListFilter title="Category" @show-form="showForm"/>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Category
          </h4>
        </template>
        <template #body>
          <AddCategory
            :categoryId="categoryId"
            v-on:list-category="getList()"
            v-on:hide-category="showFormModal = false"
          />
        </template>
      </panel-modal>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  CATEGORY LIST
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    width=""
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Category</th><!--
                        <th width="10%">Color Code</th>
                        <th width="10%">Sort Order</th>
                        <th width="10%">Status</th>-->
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in categoryList"
                        :key="item.category_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ item.category_name }}</td>
                        <!--
                        <td>{{ category.color_code }}</td>
                        <td>{{ category.sort_order }}</td>
                        <td>
                          <div class="switch">
                            <label>
                              <input type="checkbox" checked />
                              <span class="lever"></span>
                              <label
                                v-if="StatusActive == true"
                                class="label bg-green"
                              >
                                Active</label
                              >
                              <label v-else class="label bg-red">Block</label>
                            </label>
                          </div>
                        </td>
                        -->
                        <td>
                          <a
                            v-on:click="showForm(item.category_id)"
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Show pagination links -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
//import $ from 'jquery'
//import axios from 'axios'

import api from "../api";
import AddCategory from "../components/AddCategory.vue";
import PanelModal from "../components/PanelModal.vue";
import Breadcrumb from "../components/Breadcrumb.vue";
import ListFilter from "../components/ListFilter.vue";

export default {
  name: "Category",

  components: {
    Breadcrumb,
    AddCategory,
    PanelModal,
    ListFilter
},
  data() {
    return {
      breadcrumbList: [{title: 'Home', link: '#', icon: 'fa fa-dashboard', active: false },{title: 'Category List', link: false, icon: false, active: true }],
      showFormModal: false,
      baseUrl: this.$store.state.baseURL,
      categoryList: {},
      categoryId: "",
      StatusActive: true,
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_category", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.categoryList = response.data.values;
          } else {
            this.categoryList = data.categoryList;
          }
        });
    },
    showForm: function(id = '') {
      this.categoryId = id;
      this.showFormModal = true;
    },
  },
  mounted(){
    this.getList()
  }
};
</script>
